// extracted by mini-css-extract-plugin
export default {"Auth":"Auth_Auth__YOGm9","signUpWrapper":"Auth_signUpWrapper__P1aro"};